module.exports = __webpack_public_path__ + "img/section4_icon2.0a4d0f51.png";